import { render, staticRenderFns } from "./PrintResumeAccountsReceivableClient.vue?vue&type=template&id=64347efd&scoped=true"
import script from "./PrintResumeAccountsReceivableClient.vue?vue&type=script&lang=js"
export * from "./PrintResumeAccountsReceivableClient.vue?vue&type=script&lang=js"
import style0 from "./PrintResumeAccountsReceivableClient.vue?vue&type=style&index=0&id=64347efd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64347efd",
  null
  
)

export default component.exports